module.exports = __webpack_public_path__ + "img/pc_header_dark.3152a647.svg";